/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RFIDCardReference
 */
export interface RFIDCardReference {
    /**
     * 
     * @type {string}
     * @memberof RFIDCardReference
     */
    readonly id: string | null;
    /**
     * 
     * @type {number}
     * @memberof RFIDCardReference
     */
    cardNumber: number;
}

/**
 * Check if a given object implements the RFIDCardReference interface.
 */
export function instanceOfRFIDCardReference(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "cardNumber" in value;

    return isInstance;
}

export function RFIDCardReferenceFromJSON(json: any): RFIDCardReference {
    return RFIDCardReferenceFromJSONTyped(json, false);
}

export function RFIDCardReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): RFIDCardReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'cardNumber': json['cardNumber'],
    };
}

export function RFIDCardReferenceToJSON(value?: RFIDCardReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cardNumber': value.cardNumber,
    };
}

